export default __webpack_public_path__ + "static/media/16.5fb649e1.svg";